(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sis-footer"] && !Shopify.designMode) return;
  try {
    
  function sisBindFooterSummaryLinks(root) {
    var scope = root || document;
    scope.querySelectorAll('.sis-footer__summary-link').forEach(function (link) {
      if (link.dataset.sisFooterBound === 'true') return;
      link.dataset.sisFooterBound = 'true';
      link.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    });
  }

  sisBindFooterSummaryLinks();
  document.addEventListener('shopify:section:load', function (event) {
    sisBindFooterSummaryLinks(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
